import { axios } from '../../../axios';

const getRecommendedPropertiesApi = (query) => {
  return axios.get('/properties/recommended', {
    headers: {
      Authorization:`Bearer ${localStorage.getItem("token")}`
    },
    params:query
  })
}

const getAll = (query) => {
  return axios.get('/properties/all', {
    headers: {
      Authorization:`Bearer ${localStorage.getItem("token")}`
    },
    params:query
  })
}

const getFeaturedPropertiesApi = (query) => {
  return axios.get('/properties/features', {
    headers: {
      Authorization:`Bearer ${localStorage.getItem("token")}`
    },
    params:query
  })
}

const getRecentViewedPropertiesApi = () => {
  return axios.get('/properties/recentView')
}

export { getFeaturedPropertiesApi, getRecommendedPropertiesApi, getAll, getRecentViewedPropertiesApi }